// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2Kyjg","cell":"ColumnAccessor_cell__3WiI1","firstCellAccent":"ColumnAccessor_firstCellAccent__1FKvI"};